import { GraphDisplayDataAction, REPLACE_GRAPH_DISPLAY_DATA } from ".";
import { GraphDisplayData } from "non-ui/data";

export function replaceGraphDisplayData(graphdisplaydata: GraphDisplayData[]) : GraphDisplayDataAction {
	return {
		type: REPLACE_GRAPH_DISPLAY_DATA,
		payload: graphdisplaydata
	};
} 
